import { motion } from 'framer-motion';

const useCases = [
  {
    sector: 'Financial Institutions',
    desc: 'AI readiness assessment, decision-system modernisation, regulatory intelligence architecture, and strategic positioning for AI-native banking and asset management.',
  },
  {
    sector: 'Infrastructure Groups',
    desc: 'Operational intelligence restructuring, predictive governance systems, long-horizon capital deployment strategy, and AI-integrated infrastructure planning.',
  },
  {
    sector: 'Sovereign Initiatives',
    desc: 'National AI strategy advisory, institutional intelligence frameworks, sovereign technology positioning, and governance-grade transformation architecture.',
  },
  {
    sector: 'Emerging Ventures',
    desc: 'Scalable intelligence architecture from inception, AI-native operational design, strategic positioning for growth, and investor-grade systems structuring.',
  },
];

const EnterpriseUseCases = () => {
  return (
    <section className="relative py-16 lg:py-20" data-testid="enterprise-use-cases">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: 'rgba(201,162,39,0.5)' }}>
            Applied Intelligence
          </p>
          <h3
            className="text-xl md:text-2xl font-light tracking-[0.1em] text-white"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            Enterprise Use Cases
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {useCases.map((uc, i) => (
            <motion.div
              key={uc.sector}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="card-glow p-7"
              style={{
                background: 'rgba(10,22,40,0.4)',
                border: '1px solid rgba(201,162,39,0.12)',
                borderRadius: '4px',
              }}
              data-testid={`use-case-${i + 1}`}
            >
              <h4
                className="text-xs uppercase tracking-[0.15em] mb-3"
                style={{ color: '#c9a227', fontFamily: "'Cinzel', serif" }}
              >
                {uc.sector}
              </h4>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
                {uc.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EnterpriseUseCases;
